/* eslint-disable max-len */
import { useLayoutEffect, useRef, useState } from "react";
import { IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface GalleryProps {
  children: any;
  title?: string;
}

const Gallery = ({ children, title }: GalleryProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const [showScrollButtons, setShowScrollButtons] = useState<boolean>(false);

  useLayoutEffect(() => {
    const checkScroll = () => {
      if (
        ref?.current &&
        ref?.current?.scrollWidth > ref?.current?.clientWidth
      ) {
        setShowScrollButtons(true);
      } else {
        setShowScrollButtons(false);
      }
    };

    if (ref?.current && "ResizeObserver" in window) {
      setTimeout(() => {
        checkScroll(); // initial check
      }, 1000);

      const observer = new ResizeObserver(checkScroll); // check on resize

      observer.observe(ref.current);

      return () => observer.disconnect();
    }
  }, []);

  const scrollLeft = () => {
    ref?.current?.scrollBy({
      left: -500,
      behavior: "smooth"
    });
  };

  const scrollRight = () => {
    ref?.current?.scrollBy({
      left: 500,
      behavior: "smooth"
    });
  };
  return (
    <div className="grid w-full">
      {(title || showScrollButtons) && (
        <div className="h-[32px] mb-[8px] flex justify-between items-center">
          {title && (
            <p className="text-[14px] text-mono-secondaryTextColor font-['Inter']">
              {title}
            </p>
          )}
          {showScrollButtons && (
            <div className="flex gap-[8px] z-10">
              <IconButton className="h-[32px] w-[32px]" onClick={scrollLeft}>
                <ChevronLeftIcon style={{ color: "rgba(48, 47, 46, 0.56)" }} />
              </IconButton>
              <IconButton className="h-[32px] w-[32px]" onClick={scrollRight}>
                <ChevronRightIcon style={{ color: "rgba(48, 47, 46, 0.56)" }} />
              </IconButton>
            </div>
          )}
        </div>
      )}
      <div
        ref={ref}
        className="w-full flex items-end gap-[16px] overflow-x-auto hide-scroll-bar"
        // sx={{
        //   width: "100%",
        //   "& .MuiBox-root": {
        //     minWidth: "250px",
        //     width: `${width} !important`,
        //     height: `${height} !important`
        //   },
        //   ".RaImageField-image": {
        //     objectFit: "cover !important",
        //     minWidth: "250px",
        //     width: `${width} !important`,
        //     height: `${height} !important`,
        //     margin: "0px !important",
        //     borderRadius: "8px"
        //   }
        // }}
      >
        {children}
      </div>
    </div>
  );
};

export default Gallery;
